import { MessageSquare } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const chatNav: NavEntry = {
  label: 'Chat',
  icon: MessageSquare,
  path: '/chat',
  permission: 'chat:use',
  order: 5,
}
